import { FC } from 'react';
import { IBodyMapMetric } from '../../../../models/injury';
import { ChartEmptyState } from './_shared/ChartEmptyState';
import { DistributionBars } from '../../../../shared/charts/DistributionBars';
import { DistributionSlice } from '../../../../shared/charts/chart.types';
import { getPaletteColor } from './_shared/chartPalette';

interface Props {
  data: IBodyMapMetric | null;
  period?: string;
  height?: number;
}

export const BodyMapChart: FC<Props> = ({ data }) => {
  if (!data || !data.zones || data.zones.length === 0) {
    return <ChartEmptyState />;
  }

  const totalDaysLost = data.zones.reduce((sum, z) => sum + z.daysLost, 0);

  const slices: DistributionSlice[] = data.zones.map((zone, index) => ({
    id: zone.zone,
    label: zone.zone,
    value: zone.daysLost,
    percent: totalDaysLost > 0 ? Math.round((zone.daysLost / totalDaysLost) * 100) : null,
    color: getPaletteColor(index),
  }));

  return (
    <DistributionBars
      data={slices}
      labelMode="value-percent"
      valueFormatter={(v) => `${v} gg`}
      tooltipLabel="Giorni persi"
    />
  );
};
